<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :pagination.sync="sortOptions"
    class="elevation-1"
    hide-actions
  >
    <template v-slot:items="props">
      <tr>
        <td class="text-xs-center px-0">
          <MapReportStatus :mapReportStatus="props.item.status" />
        </td>
        <td class="text-xs-center px-0">
          <MdSwitch
            :value="!props.item.isAutoGenerated"
            :class="[props.item.status === 'waiting' ? 'md-primary' : '']"
            :disabled="props.item.status !== 'waiting'"
            @change="
              modifyAutoGeneratedStatus(
                props.item.id,
                !props.item.isAutoGenerated,
              )
            "
          />
        </td>
        <td class="text-xs-left no-wrap px-0">
          <ButtonEditUrl
            @updateUrl="updateUrl"
            v-if="
              enableDisplayEditUrlButton(
                props.item.status,
                props.item.isAutoGenerated,
              )
            "
            :id="props.item.id"
            :name="props.item.name"
            :status="props.item.status"
            :url="props.item.url"
            class="button-size"
          />
        </td>
        <td class="text-xs-left no-wrap px-0">
          <ButtonReject
            @updateRejectStatus="updateRejectStatus"
            :id="props.item.id"
            :name="props.item.name"
            :status="props.item.status"
          />
        </td>
        <td class="text-xs-center px-3">
          {{ props.item.id }}
        </td>
        <td class="text-xs-left px-2">
          <MapReportInsertionOrderName
            :advertiserId="props.item.advertiserId"
            :insertionOrderId="props.item.insertionOrderId"
            :insertionOrderName="props.item.insertionOrderName"
          />
        </td>
        <td class="text-xs-left px-2">{{ props.item.extractionPeriod }}</td>
        <td class="text-xs-left px-2">{{ props.item.advertiserName }}</td>
        <td class="text-xs-left px-2">
          <MapReportName
            :id="props.item.id"
            :name="props.item.name"
            :status="props.item.status"
            :url="props.item.url"
            :mapboxUrl="props.item.mapboxUrl"
          />
        </td>
        <td class="text-xs-left px-2">{{ props.item.createdTime }}</td>
      </tr>
      <MapReportRejectReason
        :status="props.item.status"
        :rejectReason="props.item.rejectReason"
      />
    </template>
  </v-data-table>
</template>

<script>
import { MapReportListRepository } from '@/models/MapReport'
import MapReportName from '@/components/Admin/Request/AdminMapReport/AdminMapReportListName'
import MapReportInsertionOrderName from '@/components/Admin/Request/AdminMapReport/AdminMapReportListInsertionOrderName'
import MapReportStatus from '@/components/Admin/Request/AdminMapReport/AdminMapReportListStatus'
import MapReportRejectReason from '@/components/Admin/Request/AdminMapReport/AdminMapReportListRejectReason'
import ButtonEditUrl from '@/components/Admin/Request/AdminMapReport/AdminMapReportListButtonEditUrl'
import ButtonReject from '@/components/Admin/Request/AdminMapReport/AdminMapReportListButtonReject'
import { mapActions, mapGetters } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'AdminMapReportRequestList',
  components: {
    MapReportName,
    MapReportInsertionOrderName,
    MapReportStatus,
    MapReportRejectReason,
    ButtonEditUrl,
    ButtonReject,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'ステータス', value: 'status', class: 'text-xs-center px-2' },
        { text: '自動発行', value: 'isAutoGenerated', class: 'px-2' },
        { text: '操作', sortable: false, class: 'px-2' },
        { text: '', sortable: false, class: 'px-2' },
        { text: 'ID', value: 'id', class: 'text-xs-center px-2' },
        { text: '案件名', value: 'insertionOrderName', class: 'px-2' },
        { text: '抽出期間', value: 'extractionDate', class: 'px-2' },
        { text: '広告主名', value: 'advertiserName', class: 'px-2' },
        { text: 'レポート名', value: 'name', class: 'px-2' },
        { text: '申請日時', value: 'createdTime', class: 'px-2' },
      ],
      sortOptions: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: -1,
      },
      activeRowId: null,
      dialog: null,
    }
  },
  computed: {
    ...mapGetters('mapReportForAdmin', [
      'keyword',
      'status',
      'isAutoGenerated',
      'pageNo',
      'mapReport',
    ]),
  },
  methods: {
    ...mapActions('mapReportForAdmin', {
      initSearchItems: 'INIT_SEARCH_ITEMS',
      setMapReport: 'SET_MAP_REPORT',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    updateMapReport() {
      this.setMapReport({
        keyword: this.keyword,
        status: this.status,
        isAutoGenerated: this.isAutoGenerated,
        pageNo: this.pageNo,
      })
    },
    // URL登録ボタンを表示する条件
    enableDisplayEditUrlButton(status, isAutoGenerated) {
      // 発行待ちかつ、手動発行
      if (status === 'waiting' && !isAutoGenerated) return true
      // 発行済み
      if (status === 'completed') return true
      // その他は表示しない
      return false
    },
    initSearch() {
      this.initSearchItems()
      this.updateMapReport()
    },
    async updateUrl(id, url) {
      const item = this.items.find(e => e.id === id)
      await MapReportListRepository.updateUrl(item.id, url)
      const updateTypeText = item.status === 'waiting' ? '登録' : '更新'
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: `${item.name}のURLを${updateTypeText}しました。`,
      })
      this.updateMapReport()
    },
    async updateRejectStatus(id, reason) {
      const item = this.items.find(e => e.id === id)

      await MapReportListRepository.updateRejectStatus(item.id, reason)

      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: `${item.name}を却下に更新しました。`,
      })
      this.updateMapReport()
    },
    async modifyAutoGeneratedStatus(id, isAutoGeneratedStatus) {
      await MapReportListRepository.modifyAutoGeneratedStatus(
        id,
        isAutoGeneratedStatus,
      )
      this.updateMapReport()
    },
  },
}
</script>

<style scoped></style>
